import { recipientService } from '../services'

const state = {
  recipients: [],
  recipient: null
}

const getters = {
  findAll (state) {
    return state.recipients
  },
  findAllAdmin (state) {
    const foundAt = state.recipients.find(recipient => recipient.id === 'other')
    state.recipients.splice(foundAt, 1)
    return state.recipients
  },
  find (state) {
    return id => state.recipients.find(recipient => recipient.id === id)
  },
  currentRecipient (state) {
    return state.recipient
  }
}

const mutations = {
  getAll (state, recipients) {
    recipients.unshift({ id: 'other', label: 'Autre' })
    state.recipients = recipients
  },
  find (state, recipient) {
    state.recipient = recipient
  },
  create (state, item) {
    const foundAt = state.recipients.findIndex(recipient => recipient.id === item.id)
    if (foundAt === -1) {
      state.recipients.push(item)
    }
  },
  update (state, { id, item }) {
    const foundAt = state.recipients.findIndex(recipient => recipient.id === id)
    state.recipients.splice(foundAt, 1, item)
  },
  delete (state, id) {
    const index = state.recipients.findIndex(recipient => recipient.id === id)

    if (index !== -1) {
      state.recipients.splice(index, 1)
    }
  }
}

const actions = {
  findAll (context) {
    return recipientService.findAll()
      .then(response => {
        context.commit('getAll', response.data)
      })
  },
  find (context, recipientId) {
    return recipientService.find(recipientId)
      .then(response => {
        context.commit('find', response.data)
        return response
      })
  },
  create (context, recipient) {
    context.dispatch('loader/startLoading', 'recipient/create', { root: true })
    return recipientService.create(recipient)
      .then(response => {
        context.dispatch('alert/success', `Création réussie du destinataire ${response.data.label}.`, { root: true })
        return response.data
      })
      .catch(() => {
        context.dispatch('alert/error', `Echec de la création du destinataire ${recipient}.`, { root: true })
      })
      .finally(() => {
        context.dispatch('loader/stopLoading', 'recipient/create', { root: true })
      })
  },
  update (context, { recipientId, recipient }) {
    context.dispatch('loader/startLoading', 'recipient/update', { root: true })
    return recipientService.update(recipientId, recipient)
      .then(response => {
        context.dispatch('alert/success', `Mise à jour réussie du destinataire ${response.data.label}.`, { root: true })
        return response.data
      })
      .catch(() => {
        context.dispatch('alert/error', `Echec de la mise à jour du destinataire ${recipient.label}.`, { root: true })
      })
      .finally(() => {
        context.dispatch('loader/stopLoading', 'recipient/update', { root: true })
      })
  },
  delete (context, recipientId) {
    return recipientService.remove(recipientId)
      .then(() => {
        context.commit('delete', recipientId)
      })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
